<template>
  <div class="live-feed">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <search-form
            ref="searchform"
            :showDates="true"
            :showSearch="true"
            :showPaging="true"
            :options="{
              permalink: 'liveFeed',
              inDetail: true,
              iconSize: '4x'
            }">
          </search-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchForm from '@/components/SearchForm'
  // import { mapGetters } from 'vuex'
  export default {
    name: 'LiveFeed',
    components: {
      SearchForm
    },
    data () {
      return {
        autoReloadTimer: ''
      }
    },
    mounted () {
      this.autoReloadTimer = setInterval(this.autoReload, 120000)
    },
    beforeDestroy () {
      clearInterval(this.autoReloadTimer)
    },
    methods: {
      autoReload () {
        this.$refs.searchform.refresh(false)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/LiveFeed.vue